export const FORM_LOGIN = {
    nombre: "",
    password: "",
  };
  